import isValidDomain from 'is-valid-domain';
import Yup from '@fourthwall/utils/dist/yup';
export const validationSchema = Yup.object().shape({
    domain: Yup.string()
        .required()
        .test('isValidDomain', 'This is not a correct domain name', (value = '') => {
        return isValidDomain(value);
    }),
});
